import { render } from "./PushConfiguration.vue?vue&type=template&id=23fd6a8c&scoped=true"
import script from "./PushConfiguration.vue?vue&type=script&lang=js"
export * from "./PushConfiguration.vue?vue&type=script&lang=js"

import "./PushConfiguration.vue?vue&type=style&index=0&id=23fd6a8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fd6a8c"]])

export default __exports__